import {IUserDTO, User} from "@/models/User";

export class Agent {
    id: string;
    name: string;
    parentId: string;
    user: User;
    rulesSourceAgent: IRulesSourceAgent | null;
    category: number | null;
    isAlwaysSegment: boolean;
    hasChildren: boolean;

    constructor(dto?: IAgentDTO)
    constructor(
        id?: string,
        name?: string,
        parentId?: string,
        user?: User,
        rulesSourceAgent?: IRulesSourceAgent | null,
        category?: number | null,
        isAlwaysSegment?: boolean,
        hasChildren?: boolean,
    )
    constructor(
        idOrDto: string | IAgentDTO = "",
        name = "",
        parentId = "",
        user = new User(),
        rulesSourceAgent = null,
        category = null,
        isAlwaysSegment = false,
        hasChildren: boolean = false,
    ) {
        if (typeof idOrDto !== "string") {
            this.id = idOrDto.id;
            this.name = idOrDto.name;
            this.parentId = idOrDto.parent ?? "";
            this.user = new User(idOrDto.user);
            this.rulesSourceAgent = idOrDto.rulesSourceAgent;
            this.category = idOrDto.category;
            this.isAlwaysSegment = idOrDto.isAlwaysSegment;
            this.hasChildren = idOrDto.isChildren || false;
        } else {
            this.id = idOrDto;
            this.name = name;
            this.parentId = parentId;
            this.user = user;
            this.rulesSourceAgent = rulesSourceAgent;
            this.category = category;
            this.isAlwaysSegment = isAlwaysSegment;
            this.hasChildren = hasChildren;
        }
    }

}

export type IAgentDTO = Readonly<{
    category: number | null;
    id: string;
    name: string;
    user: IUserDTO;
    parent: string | null;
    rulesSourceAgent: IRulesSourceAgent | null;
    isAlwaysSegment: boolean;
    /**
     * Есть ли у агента дети
     */
    isChildren?: boolean;
    agentAuthUrl?: string;
}>

export type IRulesSourceAgent = Readonly<{
    id: string;
    name: string;
}>
